// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"efd60b5d","742":"ecd58014","851":"994e4c92","880":"2c5966d6"}[chunkId] + ".chunk.js";
};